import { singleton } from 'tsyringe';

export enum SoundId {
	CAT_ATTACK = 'cat_attack',
	// İleride eklenecek:
	// CAT_DEATH = 'cat_death',
	// CAT_JUMP = 'cat_jump',
	// CAT_LAND = 'cat_land',
	// ENEMY_ATTACK = 'enemy_attack',
	// COLLECT_ITEM = 'collect_item',
}

const SOUND_PATHS: Record<SoundId, string> = {
	[SoundId.CAT_ATTACK]: './assets/sounds/angry_4.wav',
};

@singleton()
export class SoundManager {
	private context: AudioContext | null = null;
	private buffers: Map<SoundId, AudioBuffer> = new Map();
	private currentSource: AudioBufferSourceNode | null = null;
	private gainNode: GainNode | null = null;
	private _volume: number = 1.0;

	constructor() {
		this.initContext();
	}

	get volume(): number {
		return this._volume;
	}

	set volume(value: number) {
		this._volume = Math.max(0, Math.min(1, value));
		if (this.gainNode) {
			this.gainNode.gain.value = this._volume;
		}
	}

	private initContext(): void {
		if (typeof AudioContext !== 'undefined') {
			this.context = new AudioContext();
		} else {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const WebkitAudioContext = (window as any).webkitAudioContext;
			if (WebkitAudioContext) {
				this.context = new WebkitAudioContext();
			}
		}

		if (this.context) {
			this.gainNode = this.context.createGain();
			this.gainNode.connect(this.context.destination);
			this.gainNode.gain.value = this._volume;
		}
	}

	async loadAll(): Promise<void> {
		if (!this.context) return;

		const loadPromises = Object.entries(SOUND_PATHS).map(async ([id, path]) => {
			try {
				const response = await fetch(path);
				const arrayBuffer = await response.arrayBuffer();
				const audioBuffer = await this.context!.decodeAudioData(arrayBuffer);
				this.buffers.set(id as SoundId, audioBuffer);
			} catch (e) {
				console.warn(`Could not load sound ${id} from ${path}:`, e);
			}
		});

		await Promise.all(loadPromises);
	}

	play(id: SoundId): void {
		if (!this.context) return;

		const buffer = this.buffers.get(id);
		if (!buffer) {
			console.warn(`Sound not loaded: ${id}`);
			return;
		}

		// Stop previous sound if playing
		if (this.currentSource) {
			try {
				this.currentSource.stop();
			} catch {
				// Already stopped
			}
		}

		this.currentSource = this.context.createBufferSource();
		this.currentSource.buffer = buffer;
		// GainNode varsa ona bağla, yoksa doğrudan destination'a
		if (this.gainNode) {
			this.currentSource.connect(this.gainNode);
		} else {
			this.currentSource.connect(this.context.destination);
		}
		this.currentSource.start(0);
	}

	getContext(): AudioContext | null {
		return this.context;
	}
}
